import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import BraftEditor from 'braft-editor'
import { Form, Input, Select, message, Row, Col, Button } from 'antd'
import { getChildrenDicts } from '@/services/homeService.ts';
import {
  addNewContractTemplate,
  queryContractTemplateDetail,
  uploadContractTemplate,
  getPrintPaperDirectionEnum,
  previewPrintTemplate,
} from '@/services/goods'
import { uploadFile } from '@/services'
import styles from './index.module.less'
import { getFileUrlPrefix } from 'shj-utils'

export default function ContentModal ({ list = {}, editId = '', open = false, onClose = () => {}})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({
    printPaperDirection: [], // 打印纸张方向
    signKeyCode: [], // 签字关键字
    printPaperType: [], // 打印纸张类型
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [buttonPdfLoading, setButtonPdfLoading] = useState(false);
  const [editorState, seteditorState] = useState<any>(BraftEditor.createEditorState(null))

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  useEffect(() => {
    if (editId) {
      getDetail(editId);
    }
  }, [editId]);

  const fetchDictionaryData = async () => {
    try {
      const printPaperDirectionRes: any = await getPrintPaperDirectionEnum();
      const dictionaryList = await getChildrenDicts([
        'signKeyCode',
        'printPaperType',
        'sealKeyCode',
      ]);
      let printPaperDirectionList = [];
      if (printPaperDirectionRes?.length) {
        printPaperDirectionList = printPaperDirectionRes.map(contract => ({
          label: contract?.description,
          value: contract?.key,
        }));
      }
      if ((dictionaryList as Array<any>)?.length) {
        const dicDataMap: any = {};
        (dictionaryList as Array<any>)?.forEach((dic: any) => {
          const dataList = dic?.children?.map((item: any) => ({
            label: item.name,
            value: item.priKey,
          }));
          dicDataMap[dic?.priKey] = dataList
        });
        dicDataMap['printPaperDirection'] = printPaperDirectionList;
        setDictionaryData(dicDataMap);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getDetail = async (id) => {
    try {
      const res: any = await queryContractTemplateDetail({ id });
      if (res?.id) {
        form.setFieldsValue({ ...res });
      }
    } catch(err) {
      console.log(err)
    }
  }

  const onEditorUpload = async obj => {
    const { blobInfo, succFun, failFun } = obj
    const dataForm = new FormData()
    dataForm.append('file', blobInfo.blob(), blobInfo.filename())
    uploadFile(dataForm)
      .then(res => {
        succFun(`${res?.fileUrl}`)
      })
      .catch(failFun)
  }

  const onSubmit = () => {
    form.validateFields().then(async (values: any) => {
      try {
        setButtonLoading(true);
        let res: any = {};
        if (editId) { // 编辑
          res = await uploadContractTemplate({
            id: editId,
            ...values,
          })
        } else { // 新增
          res= await addNewContractTemplate({
            ...values,
          })
        }
        if (res?.id) {
          message.success('保存成功');
          setButtonLoading(false);
          onClose();
          (list as any)?.current?.reload();
        } else {
          setButtonLoading(false);
          message.error('保存失败');
          return;
        }
      } catch (err) {
        setButtonLoading(false);
        console.log(err)
      }
    })
  }

  const onDetailPdf = () => {
    form.validateFields().then(async (values: any) => {
      try {
        setButtonPdfLoading(true);
        console.log(values)
        const {paperDirection,paperType,content} = values;
        const record:any= await previewPrintTemplate({landscape:paperDirection==="Landscape",format:paperType,htmlBody:content});
        if (record?.filePath) {
          const url =await getFileUrlPrefix();
          window.open(url+record.filePath)
          return;
        }else {
          message.error('没有返回正确的合同地址！');
        }
      } finally {
        setButtonPdfLoading(false);
      }
    })
  }

  return (
    <div className={styles.contractContentModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={buttonLoading}
        width="50%"
      >
        <Form
          form={form}
          name="basicInfo"
          layout="vertical"
        >
          <Row gutter={15} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col span={12}>
              <Form.Item
                  name="name"
                  label="名称"
                  rules={[
                    {
                      required: true,
                      message: '请填写名称',
                    },
                  ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                  name="paperType"
                  label="纸张"
                  rules={[
                    {
                      required: true,
                      message: '请选择纸张',
                    },
                  ]}
              >
                <Select options={dictionaryData['printPaperType']} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                  name="paperDirection"
                  label="纸张方向"
                  rules={[
                    {
                      required: true,
                      message: '请选择纸张方向',
                    },
                  ]}
              >
                <Select options={dictionaryData['printPaperDirection']}></Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                  name="signKeyCode"
                  label="签字关键字"
                  rules={[
                    {
                      required: true,
                      message: '请选择签字关键字',
                    },
                  ]}
              >
                <Select options={dictionaryData['signKeyCode']}></Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                  name="sealKeyCode"
                  label="盖章关键字"
                  rules={[
                    {
                      required: true,
                      message: '请选择盖章关键字',
                    },
                  ]}
              >
                <Select options={dictionaryData['sealKeyCode']}></Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Form.Item
              name="content"
              label={
                <div className={styles.contentTitle}>
                  <span>合同内容</span>
                  <Button loading={buttonPdfLoading} type="primary" onClick={onDetailPdf}>预览</Button>
                </div>
              }
              rules={[
                {
                  required: true,
                  message: '请输入合同内容',
                },
              ]}
              style={{
                width: '100%'
              }}
              labelCol={{
                span: 24
              }}
            >
              <SEditor
                // readOnly
                toolbar="fullscreen | code codesample |code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | styleselect formatselect fontselect fontsizeselect| bullist numlist| blockquote subscript superscript removeformat| table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs"
                onUpload={onEditorUpload}
                value={editorState}
                onChange={(editorState: any) => {
                  seteditorState(editorState)
                }}
              />
            </Form.Item>
          </Row>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
